import React, { FC, ReactElement } from 'react';
import { Button } from '@zydalabs/zac-react';
import { destroyCookie } from 'nookies';

import { USER_AUTHENTICATION_COOKIE } from 'common/constants';
import { getFullDomain, redirectToOrderFast } from 'common/utils';
import { useRouter } from 'next/router';
import { usePersistedCountryDetails } from 'common/hooks';

type LogoutButtonProps = {
  size: 'small' | 'medium' | 'large';
  variant: 'primary' | 'secondary' | 'skeleton' | 'tertiary' | 'danger' | 'ghost' | 'danger-tertiary' | 'danger-ghost';
  text: string;
  isFluid?: boolean;
  isDisabled?: boolean;
  testId?: string;
  rounded?: boolean;
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  isLoading?: boolean;
};

const LogoutButton: FC<LogoutButtonProps> = ({ ...props }) => {
  const router = useRouter();
  const [persistedCountryDetails] = usePersistedCountryDetails();
  const { code } = persistedCountryDetails || {};
  const signout = () => {
    destroyCookie(null, USER_AUTHENTICATION_COOKIE, { path: '/', domain: getFullDomain() });
    redirectToOrderFast({
      path: router.asPath,
      locale: router.locale,
      forceLogin: true,
      countryCode: code,
    });
  };

  return <Button onClick={signout} {...props} />;
};

export default LogoutButton;
